import { apiClient } from '../../../platform/api/apiClient';

export const rifleService = {
    getScoreSheets() {
        return apiClient.get('RifleScoreSheet');
    },

    getEventScoreSheets(eventId) {
        return apiClient.get(`RifleScoreSheet/event/${eventId}`);
    },

    getScoreSheet(scoreSheetId) {
        return apiClient.get(`RifleScoreSheet/${scoreSheetId}`);
    },

    createScoreSheet(payload) {
        return apiClient.post('RifleScoreSheet', { json: payload });
    },

    updateScoreSheet(scoreSheetId, payload) {
        return apiClient.put(`RifleScoreSheet/${scoreSheetId}`, { json: payload });
    },

    addRound(scoreSheetId, payload) {
        return apiClient.post(`RifleScoreSheet/${scoreSheetId}/rounds`, { json: payload });
    },

    updateRound(scoreSheetId, roundId, payload) {
        return apiClient.put(`RifleScoreSheet/${scoreSheetId}/rounds/${roundId}`, { json: payload });
    },

    deleteScoreSheet(scoreSheetId) {
        return apiClient.del(`RifleScoreSheet/${scoreSheetId}`);
    },

    getZeros() {
        return apiClient.get('RifleZero');
    },

    getZero(zeroId) {
        return apiClient.get(`RifleZero/${zeroId}`);
    },

    createZero(payload) {
        return apiClient.post('RifleZero', { json: payload });
    },

    updateZero(zeroId, payload) {
        return apiClient.put(`RifleZero/${zeroId}`, { json: payload });
    },

    deleteZero(zeroId) {
        return apiClient.del(`RifleZero/${zeroId}`);
    },

    getTrainingSessions() {
        return apiClient.get('TrainingSession');
    },

    getTrainingStats() {
        return apiClient.get('TrainingSession/stats');
    },

    getTrainingSession(sessionId) {
        return apiClient.get(`TrainingSession/${sessionId}`);
    },

    createTrainingSession(payload) {
        return apiClient.post('TrainingSession', { json: payload });
    },

    updateTrainingSession(sessionId, payload) {
        return apiClient.put(`TrainingSession/${sessionId}`, { json: payload });
    },

    deleteTrainingSession(sessionId) {
        return apiClient.del(`TrainingSession/${sessionId}`);
    }
};
